const ALL_ARITHMETICS = [
    "addition",
    "subtraction",
    "multiplication",
    "division",
];

export default ALL_ARITHMETICS;
